import { useState } from "react";
import { useNavigate } from "react-router-dom";
import './type-search.css';

export default function TypeSearchForm() {
  const [inputValue, setInputValue] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    const match = inputValue.match(/(\d+)\/(\d+)/);
    if (inputValue.trim() === '') {
        setError("Write number in the format SAR, T #####/#####");
        return;
      }
    if (match) {
      const [, first, second] = match;
      navigate(`/type/${first}/${second}`);
    } else {
      setError("Wrong type reference format, please try again");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="type-search-form">
  <input
    type="text"
    placeholder="SAR, T 10003/10004"
    value={inputValue}
    onChange={(e) => {
      setInputValue(e.target.value);
      setError("");
    }}
    className="type-search-input"
  />
  {error && (
    <div className="type-search-error">{error}</div>
  )}
  <button type="submit" className="toggle-button">
    Go
  </button>
</form>
  );
}
